class ProductEditorialDescription {
  constructor(container) {
    this.container = container;
    this.body = container.querySelector('[data-description-body]');
    this.toggle = container.querySelector('[data-description-toggle]');
    this.collapsedLabel = container.querySelector('[data-collapsed-label]');
    this.expandedLabel = container.querySelector('[data-expanded-label]');

    if (!this.body || !this.toggle || container.dataset.editorialInit === 'true') return;
    container.dataset.editorialInit = 'true';

    this.isExpanded = false;
    this.onToggleBound = this.onToggle.bind(this);
    this.onResizeBound = this.sync.bind(this);
    this.toggle.addEventListener('click', this.onToggleBound);
    this.sync();
    window.addEventListener('resize', this.onResizeBound, { passive: true });
  }

  sync() {
    const canExpand = this.body.scrollHeight > this.body.clientHeight + 4;
    this.toggle.hidden = !canExpand && !this.isExpanded;
  }

  onToggle() {
    this.isExpanded = !this.isExpanded;
    this.container.classList.toggle('is-expanded', this.isExpanded);
    this.toggle.setAttribute('aria-expanded', this.isExpanded ? 'true' : 'false');
    this.collapsedLabel.hidden = this.isExpanded;
    this.expandedLabel.hidden = !this.isExpanded;
    this.sync();
  }
}

class ProductSizeGuideTabs {
  constructor(container) {
    this.container = container;
    this.tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

    if (container.dataset.sizeGuideInit === 'true') return;
    container.dataset.sizeGuideInit = 'true';

    if (this.tabs.length < 2 || this.panels.length < 2) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activateTab(tab, true));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activateTab(tab, moveFocus = false) {
    const panelId = tab.getAttribute('aria-controls');

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });

    if (moveFocus) tab.focus();
  }

  onKeydown(event, index) {
    let nextIndex = index;

    switch (event.key) {
      case 'ArrowRight':
      case 'Right':
        nextIndex = (index + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'Left':
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activateTab(this.tabs[nextIndex], true);
  }
}

function isEffectivelyEmptyCell(cell) {
  if (!cell) return true;
  const media = cell.querySelector('img, svg, video, iframe, canvas');
  if (media) return false;
  const text = (cell.textContent || '')
    .replace(/[\u00a0\u200b\u200c\u200d\ufeff]/g, ' ')
    .trim();
  return text.length === 0;
}

function normalizeSizeGuideTables(root = document) {
  root.querySelectorAll('.js-size-guide-modal .size-guide-modal__panel table').forEach((table) => {
    if (table.dataset.columnsNormalized === 'true') return;

    const rows = Array.from(table.rows || []);
    if (!rows.length) return;

    const columnCount = rows.reduce((max, row) => Math.max(max, row.cells.length), 0);
    if (columnCount < 2) return;

    const emptyColumns = [];

    for (let colIndex = 0; colIndex < columnCount; colIndex += 1) {
      const isEmptyAcrossRows = rows.every((row) => isEffectivelyEmptyCell(row.cells[colIndex]));
      if (isEmptyAcrossRows) emptyColumns.push(colIndex);
    }

    if (emptyColumns.length) {
      const colgroupColumns = Array.from(table.querySelectorAll('colgroup col'));
      if (colgroupColumns.length) {
        emptyColumns
          .slice()
          .reverse()
          .forEach((colIndex) => {
            const col = colgroupColumns[colIndex];
            if (col) col.remove();
          });
      }

      rows.forEach((row) => {
        emptyColumns
          .slice()
          .reverse()
          .forEach((colIndex) => {
            const cell = row.cells[colIndex];
            if (cell) cell.remove();
          });
      });
    }

    table.dataset.columnsNormalized = 'true';
  });
}

function initProductEditorialDescriptions(root = document) {
  root.querySelectorAll('.js-product-editorial-description').forEach((container) => {
    new ProductEditorialDescription(container);
  });
}

function initProductSizeGuides(root = document) {
  root.querySelectorAll('.js-size-guide-modal').forEach((container) => {
    new ProductSizeGuideTabs(container);
  });

}

document.addEventListener('DOMContentLoaded', () => {
  initProductEditorialDescriptions(document);
  initProductSizeGuides(document);
  normalizeSizeGuideTables(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initProductEditorialDescriptions(event.target);
  initProductSizeGuides(event.target);
  normalizeSizeGuideTables(event.target);
});

document.addEventListener('product-info:loaded', (event) => {
  initProductEditorialDescriptions(event.target);
  initProductSizeGuides(event.target);
  normalizeSizeGuideTables(event.target);
});
